import React, { useState, useEffect, ChangeEvent, useRef } from "react"
import {
    Button,
    CardBody,
    IconButton,
    Input,
    Spinner,
    Typography,
} from "@material-tailwind/react"
import { CustomHeader } from "../../../components/headers/CustomHeader"
import { SubmitHandler, useFieldArray, useForm } from "react-hook-form"
import { BiPlus } from "react-icons/bi"
import { IoMdCheckmark } from "react-icons/io"
import { UserType } from "../../../types/user"
import { useQuery } from "@apollo/client"
import { DEFAULTPRIMARYCOLOR, BASEURL, id_types } from "../../../util"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { FaSave } from "react-icons/fa";
import { GET_DRIVER_DETAILS, GETALLCOLORS, GET_ALL_DRIVERS, GET_DRIVER_STATIONS } from "../../../GraphQl/queries"
import { FiX } from "react-icons/fi"

export type DriversDataType = {
    account_status: string
    balance: number
    date_created: string
    driver_code: string
    driver_id: string
    driver_name: string
    phone_number: string
    total_number_of_policies: number
    total_premium_balance: number
    total_premium_paid: number
    total_premium_payable: number
    total_arrears: number
    wallet_number: string
    usertype: string
    created_by: string
}

export interface Driver {
    account_status: string;
    address: string;
    balance: number;
    bank_details: any;
    created_at: string;
    created_by: string;
    dob: string;
    driver_code: string;
    email: string;
    first_name: string;
    full_name: string;
    gender: string;
    ghana_card_back: string | null;
    ghana_card_front: string | null;
    id_card_type: string;
    id_number: string;
    is_deleted: boolean;
    momo_wallet_details: {
        network: string;
        phone_number: string;
    }
    other_name: string;
    phone_number_1: string;
    phone_number_2: string;
    station: string | null;
    surname: string;
    driver_beneficiaries?: DriverBeneficiary[] | null;
    __typename?: string;
}

export type localDriver = {
    driver_id: string
    driver_name: string
    driver_phone: string
    deposit_balance: number
    driver_status: string
    date_created: string
}

type FormType = {
    first_name: string
    surname: string
    other_name: string
    gender: string
    dob: string
    phone_number_1: string
    phone_number_2: string
    email: string
    id_card_type: string
    id_number: string
    address: string
    momo_wallet_details: {
        network: string
        number: string
    }
    bank_details: {}
    beneficiaries?: Beneficiary[];
    consent: true
    station: string
    signature: string
    driver_id: string
}

type Beneficiary = {
    first_name: string;
    surname: string;
    dob: string;
    email?: string;
    phone_number: string;
    address: string;
    relationship: string;
    share_percentage: number;
};

type DriverBeneficiary = {
    id: string
    first_name: string
    surname: string
    phone_number: string
    share_percentage: number
}

type BeneficiaryType = DriverBeneficiary | Beneficiary;

type BankData = {
    status: string
    reason: string
    transactionid: number
    accountno: string
    accountname: string
}

type PhoneDataType = {
    status: string
    reason: string
    transactionid: number
    accountno: string
    accountname: string
}

type DriverStationType = {
    id: string;
    name: string;
};

const DriverEdit = () => {
    const [RequestLoading, setRequestLoading] = useState(false)
    const [formData, setFormData] = useState<any | null>(null)
    const [loading, setLoading] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [errors, setErrors] = useState<any | null>(null)
    const [phoneNum, setPhoneNum] = useState("")
    const [network, setNetwork] = useState("")
    const [bankCode, setBankCode] = useState("")
    const [bankNum, setBankNum] = useState("")
    const [phoneData, setPhoneData] = useState<PhoneDataType | null>(null)
    const [bankData, setBankData] = useState<BankData | null>(null)
    const [loadVal, setLoadVal] = useState(false)
    const [loadValB, setLoadValB] = useState(false)
    const [phoneValidated, setPhoneValidated] = useState(false)
    const [bankValidated, setBankValidated] = useState(false)

    const createEmptyBeneficiary = (): Beneficiary => ({
        first_name: "",
        surname: "",
        dob: "",
        email: "",
        phone_number: "",
        address: "",
        relationship: "",
        share_percentage: 0,
    });

    const {
        register,
        handleSubmit,
        reset,
        formState: { isSubmitting, errors: updateError },
        setValue,
        control,
        watch,
    } = useForm<FormType>(
        {
            defaultValues: {
                station: formData?.station || "",  // <-- this sets the default selected station
                // other fields...
            },
        }
    )


    const {
        companyId,
        roleId,
        usertype,
        user: stateUser,
        token,
    } = useSelector((state: RootState) => state.auth)


    const driver = JSON.parse(
        localStorage.getItem("driver") || "{}"
    ) as localDriver


    const { data: driverData, loading: loadingDriver, error } = useQuery<{
        drivers: Driver[];
    }>(GET_DRIVER_DETAILS, {
        variables: {
            id: driver?.driver_id,
        },
        skip: !driver?.driver_id,
    });



    const {
        data: stations,
        loading: loadingStations,
        refetch
    } = useQuery<{
        driver_stations: DriverStationType[];
    }>(GET_DRIVER_STATIONS);





    useEffect(() => {
        if (driverData == undefined) {
            console.log("Error fetching data")
        }
        if (driverData?.drivers && driverData.drivers.length > 0) {
            setFormData(driverData.drivers[0]);
        }
    }, [driverData]);


    const [beneficiaries, setBeneficiaries] = useState<BeneficiaryType[]>(
        (driverData?.drivers[0]?.driver_beneficiaries ?? [createEmptyBeneficiary()])
    );

    useEffect(() => {
        if (driverData && driverData.drivers && driverData.drivers.length > 0) {
            setFormData((prev: any) => ({
                ...prev,
                beneficiaries:
                    driverData?.drivers?.[0]?.driver_beneficiaries?.length
                        ? driverData.drivers[0].driver_beneficiaries
                        : [createEmptyBeneficiary()],
            }));
        }
    }, [driverData]);


    useEffect(() => {
        if (driverData?.drivers[0]?.id_card_type) {
            setValue("id_card_type", driverData?.drivers[0].id_card_type);
        }
    }, [driverData?.drivers[0]?.id_card_type, setValue]);

    useEffect(() => {
        const stationsLoaded = Array.isArray(stations?.driver_stations) && stations && stations?.driver_stations.length > 0;

        if (formData && stationsLoaded) {
            reset({
                first_name: formData.first_name || "",
                surname: formData.surname || "",
                other_name: formData.other_name || "",
                gender: formData.gender || "",
                dob: formData.dob || "",
                phone_number_1: formData.phone_number_1 || "",
                phone_number_2: formData.phone_number_2 || "",
                email: formData.email || "",
                id_card_type: formData.id_card_type || "",
                id_number: formData.id_number || "",
                address: formData.address || "",
                station: formData.station || "", // this will match when stations are ready
                signature: formData.signature || "",
                consent: true,
                beneficiaries: formData.driver_beneficiaries || [],
                momo_wallet_details: {
                    network: formData.momo_wallet_details?.network || "",
                    number: formData.momo_wallet_details?.number || "",
                },
            });
        }
    }, [formData, stations, reset]);









    const onSubmit: SubmitHandler<FormType> = async (data) => {


        try {
            const formPayload = {
                first_name: data.first_name,
                surname: data.surname,
                other_name: data.other_name,
                gender: data.gender,
                dob: data.dob,
                phone_number_1: data.phone_number_1,
                phone_number_2: data.phone_number_2,
                email: data.email,
                id_card_type: data.id_card_type,
                id_number: data.id_number,
                address: data.address,
                momo_wallet_details: {
                    network: network,
                    number: phoneNum
                },
                // bank_details: {},
                beneficiaries: data.beneficiaries
                    ?.filter(b => b.dob && b.first_name && b.surname) // skip blanks
                    .map((b) => ({
                        first_name: b.first_name,
                        surname: b.surname,
                        dob: b.dob,
                        phone_number: b.phone_number,
                        email: b.email,
                        address: b.address,
                        relationship: b.relationship,
                        share_percentage: b.share_percentage,
                    })) ?? [],
                consent: data.consent,
                station: data.station,
                signature: data.signature || '',
                driver_id: driver?.driver_id,
            }

            setLoading(true);
            const response = await fetch(`${process.env.REACT_APP_BASE_URL}/update-driver-dashboard`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(formPayload),
            });

            const result = await response.json();

            if (response.ok) {
                toast.success(result?.message ?? "Driver details successfully updated");
            } else {
                toast.error(result?.detail ?? result?.data ?? "Failed to update driver details");
            }
            setLoading(false);
        } catch (err) {
            console.error("Error submitting data:", err);
            toast.error("Error submitting data, please try again!");
            setLoading(false);
        }
    };


    const userData = localStorage.getItem("user")
    const [colors, setColors] = useState<string[]>()

    useEffect(() => {
        if (userData) {
            const data: UserType = JSON.parse(userData)

            setColors(data.colors)
        }
    }, [userData])

    const { fields, append, remove } = useFieldArray({
        control,
        name: "beneficiaries"
    });

    useEffect(() => {
        if (fields.length === 0) {
            append({
                first_name: "",
                surname: "",
                dob: "",
                email: "",
                phone_number: "",
                address: "",
                relationship: "",
                share_percentage: 0,
            });
        }
    }, [fields, append]);


    const addBeneficiary = () => {
        const updated: BeneficiaryType[] = [...beneficiaries, createEmptyBeneficiary()];
        setBeneficiaries(updated);
    };


    const fxnPhone = async () => {
        try {
            setLoadVal(true)
            const res = await fetch(`${BASEURL}/validate-account-details`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                    accountnumber: "",
                    bankcode: "",
                    network: network,
                    accounttype: "MOBILE_MONEY",
                    walletnumber: phoneNum,
                }),
            })

            if (!res.ok) {
                toast.error("validation faild")
                return
            }

            const data = await res.json()

            if (!data) {
                toast.error("validation failed")
                return
            }
            if (data?.status === "Rejected" || data?.status === "User not found") {
                toast.error("Validation failed")
                setPhoneValidated(false)
                setPhoneData(null)
                return
            } else {
                setPhoneData(data)
                setPhoneValidated(true)
                toast.success("Phone number validated successfully")
            }
        } catch (e) {
        } finally {
            setLoadVal(false)
        }
    }

    // Get Colors
    interface ColorOptions {
        label: string;
        value: string;
    }

    interface UseColorClassOptionsReturn {
        colorClassOptions: ColorOptions[];
        error?: string;
    }

    const useColorClassOptions = (): UseColorClassOptionsReturn => {
        const { data, loading, error } = useQuery(GETALLCOLORS);

        if (loading || !data) return { colorClassOptions: [] };
        if (error) return { error: error.message, colorClassOptions: [] };

        const colorClassOptions: ColorOptions[] = data.colors?.map((color: any) => ({
            label: color.name,
            value: color.id?.toString() ?? "",
        })) || [];

        return { colorClassOptions };
    };

    const { colorClassOptions, error: colorClassError } = useColorClassOptions();

    const onError = (errors: any) => {
        toast.error("Validation failed. Check required fields.");
        if (errors.phone_number_1) {
            toast.error(errors.phone_number_1.message);
        }
        if (errors.phone_number_2) {
            toast.error(errors.phone_number_2.message);
        }
        // Add toasts for other fields if needed
    };

    return (
        <>
            {loadingDriver && (
                <div className="flex items-center justify-center h-screen">
                    <Spinner className="w-10 h-10" />
                </div>
            )
            }
            <div className="flex w-full justify-between items-center">
                <CustomHeader title="Edit driver information" />

            </div>
            <form
                onSubmit={handleSubmit(onSubmit, onError)}
                className="w-full"
            >
                <div className="w-full flex flex-col md:flex-row lg:flex-row gap-5">
                    <div className=" rounded-lg overflow-y-scroll w-full  lg:w-3/4">
                        <div className="w-full flex flex-col space-y-4">
                            <div className="p-3 bg-white rounded-b-xl ">
                                <Typography className="text-lg font-bold">
                                    Driver Information{" "}
                                </Typography>
                                <div>
                                    <div className="grid grid-cols-2 gap-4 mt-4">
                                        <Input
                                            crossOrigin="anonymous"
                                            size="lg"
                                            type="text"
                                            className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                            label="First Name"
                                            // defaultValue={formData?.first_name}
                                            // value={watch("first_name") || formData?.first_name || ""}
                                            // onChange={(e) => handleChange(e)}
                                            {...register("first_name", { required: true })}
                                        />
                                        <Input
                                            crossOrigin="anonymous"
                                            size="lg"
                                            className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                            label="Last Name"
                                            // defaultValue={
                                            //     formData?.surname
                                            // }
                                            // value={formData?.surname ? formData?.surname : watch("surname") || ""}
                                            // onChange={(e) => handleChange(e)}
                                            {...register("surname", { required: true })}
                                        />
                                        <Input
                                            crossOrigin="anonymous"
                                            size="lg"
                                            className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                            label="Other Name"
                                            // defaultValue={
                                            //     formData?.other_name
                                            // }
                                            // value={watch("other_name") || formData?.other_name }
                                            // onChange={(e) => handleChange(e)}
                                            {...register("other_name", { required: false })}
                                        />
                                        <select
                                            className="h-11 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500l"
                                            // defaultValue={formData?.gender}
                                            // onChange={(e) => handleSelectChange(e)}
                                            // value={formData?.gender || ""}
                                            {...register("gender", { required: true })}
                                        >
                                            <option value="">Gender</option>
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </select>
                                        <Input
                                            // defaultValue={formData?.dob}
                                            // value={watch("dob") || ""}
                                            crossOrigin="anonymous"
                                            size="md"
                                            type="date"
                                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                            labelProps={{
                                                className: "before:content-none after:content-none",
                                            }}
                                            {...register("dob", { required: true })}
                                        />
                                        <Input
                                            crossOrigin="anonymous"
                                            size="lg"
                                            className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                            label="Email"
                                            {...register("email", {
                                                required: false,
                                                pattern: {
                                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                    message: "Invalid email address",
                                                },
                                            })}
                                        />
                                        <Input
                                            crossOrigin="anonymous"
                                            size="lg"
                                            className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                            label="Phone Number 1"
                                            {...register("phone_number_1", {
                                                required: "Phone number is required",
                                                onChange: (e) => {
                                                    const cleaned = e.target.value.replace(/\s+/g, "");
                                                    setValue("phone_number_1", cleaned);
                                                },
                                                validate: (value) => {
                                                    if (!/^\d+$/.test(value)) {
                                                        // toast.error("Phone number must contain only digits");
                                                        return "Phone number must contain only digits";
                                                    }
                                                    if (value.length < 10) {
                                                        // toast.error("Phone number must be at least 10 digits");
                                                        return "Phone number must be at least 10 digits";
                                                    }
                                                    return true;
                                                }
                                            })}

                                        />
                                        <Input
                                            crossOrigin="anonymous"
                                            size="lg"
                                            className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                            label="Phone Number 2"
                                            // defaultValue={
                                            //     formData?.phone_number_2
                                            // }
                                            // value={watch("phone_number_2") || ""}
                                            {...register("phone_number_2", {
                                                required: false,
                                                onChange: (e) => {
                                                    const raw = e.target.value ?? "";
                                                    const cleaned = raw.replace(/\s+/g, "");
                                                    setValue("phone_number_2", cleaned);
                                                },
                                                validate: (value) => {
                                                    if (!value) return true;

                                                    if (!/^\d+$/.test(value)) {
                                                        return "Phone number must contain only digits";
                                                    }
                                                    if (value.length < 10) {
                                                        return "Phone number must be at least 10 digits";
                                                    }
                                                    return true;
                                                }
                                            })}
                                        />
                                        <Input
                                            crossOrigin="anonymous"
                                            size="lg"
                                            className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                            label="Address"
                                            {...register("address", { required: true })}
                                        />

                                        <select
                                            // defaultValue={formData?.station}
                                            {...register("station", { required: true })}
                                            className="h-11 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                        >
                                            <option value="">Select Station</option>
                                            {stations?.driver_stations?.map((station) => (
                                                <option key={station.id} value={station.id}>
                                                    {station.name}
                                                </option>
                                            ))}

                                        </select>
                                        <select
                                            className="h-11 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            {...register("id_card_type", { required: true })}
                                        >
                                            <option value="">National ID Type</option>
                                            <option value="Ghana Card">Ghana Card</option>
                                            {id_types?.map((item: any) => (
                                                <option value={item?.name} label={item?.name}>
                                                    {item?.name}
                                                </option>
                                            ))}
                                        </select>
                                        <Input
                                            crossOrigin="anonymous"
                                            size="lg"
                                            className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                            label="ID number"
                                            {...register("id_number", { required: true })}
                                        />
                                        {/* <Input
                                        crossOrigin="anonymous"
                                        size="lg"
                                        className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                        label="Ghana Card (Front)"
                                        defaultValue={formData?.ghana_card_front}
                                        // onChange={(e) => handleChange(       e)}
                                        {...register("ghana_card_front", { required: true })}
                                    />
                                    <Input
                                    crossOrigin="anonymous"
                                    size="lg"
                                    className="bg-gray-100 flex items-center w-full px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                    label="Ghana Card (Back)"
                                    defaultValue={formData?.ghana_card_back}
                                    // onChange={(e) => handleChange(e)}
                                    {...register("ghana_card_back", { required: true })}
                                    /> */}
                                    </div>
                                    <hr className="my-1 mt-6" />
                                    <Typography className="text-md text-gray-600 pt-3">
                                        Mobile Money Details
                                    </Typography>
                                    <div className="grid grid-cols-2 gap-4 mt-4">
                                        <select
                                            {...register("momo_wallet_details.network", {
                                                required: false,
                                            })}
                                            onChange={(e) => {
                                                setNetwork(e.target.value)
                                            }}
                                            className="h-11 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                            defaultValue={network ?? formData?.momo_wallet_details?.network}
                                        >
                                            <option label="Select Network" value="">
                                                Select Network
                                            </option>
                                            <option label="MTN" value={"MTN"}>
                                                MTN
                                            </option>
                                            <option label="AirtelTigo" value={"AIRTELTIGO"}>
                                                AirtelTigo
                                            </option>
                                            <option label="Vodafone" value={"VODAFONE"}>
                                                Vodafone
                                            </option>
                                        </select>
                                        <Input
                                            {...register("momo_wallet_details.number", {
                                                required: false,
                                            })}
                                            onChange={(e) => {
                                                setPhoneNum(e.target.value)
                                            }}
                                            crossOrigin="anonymous"
                                            placeholder="Wallet Number"
                                            size="md"
                                            className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
                                            labelProps={{
                                                className:
                                                    "before:content-none after:content-none",
                                            }}
                                        />
                                    </div>
                                    {(phoneNum || network) && (
                                        <div className="flex items-center justify-between">
                                            {phoneValidated && phoneData ? (
                                                <div className="text-green-500 flex items-center text-[0.85rem] gap-x-3">
                                                    <div>{phoneData?.accountname}</div>
                                                    <div>
                                                        <IoMdCheckmark
                                                            size={22}
                                                            className=" text-green-500 text-xl"
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="text-[0.85rem]">
                                                    <p className=" text-red-500">
                                                        Not validated yet{" "}
                                                        <span className=" ml-1 text-red-500 text-[1.2rem]">
                                                            x
                                                        </span>
                                                    </p>
                                                    <p className="text-red-500">
                                                        Wallet number is required
                                                    </p>
                                                </div>
                                            )}

                                            <button
                                                onClick={(e) => {
                                                    e.preventDefault()
                                                    fxnPhone()
                                                }}
                                                className=" bg-green-400 px-[0.4rem] rounded-md text-white p-[0.2rem]"
                                            >
                                                {loadVal ? "validating..." : "validate"}
                                            </button>
                                        </div>
                                    )}
                                    <hr className="my-1 mt-6" />
                                    <Typography className="text-md text-gray-600 pt-3">
                                        Consent
                                    </Typography>
                                    <label className="flex items-center space-x-2 my-2">
                                        <input
                                            type="checkbox"
                                            {...register("consent", { required: true })}
                                            defaultChecked={formData?.consent}
                                            className="bg-gray-100 flex items-center px-5 py-4 mr-2 text-sm font-medium outline-none focus:bg-grey-400 placeholder:text-grey-700 bg-grey-200 text-dark-grey-900 rounded-2xl"
                                        />
                                        <span>Consent Given</span>
                                    </label>
                                </div>
                            </div>
                            {/* <div className="mt-5 mb-4 flex gap-4 items-end justify-end">
                        <Button
                            type="submit"
                            size="sm"
                            className="capitalize flex items-center flex-row items-centerfont-normal"
                            style={{
                                background:
                                    colors?.length! > 1
                                        ? `${colors![0]?.toLowerCase()}`
                                        : `${DEFAULTPRIMARYCOLOR}`,
                            }}
                        >
                            <BiPlus size={20} />
                            {loading ? <Spinner className="w-4 h-4" /> : "Save"}
                        </Button>
                    </div> */}
                            <div className="p-3 bg-white rounded-b-xl rounded-t-xl">
                                <Typography className="text-lg font-bold">Beneficiary Information</Typography>

                                {fields.map((beneficiary, index) => (
                                    <React.Fragment key={index}>
                                        {index > 0 && (
                                            <div>
                                                <hr className="my-1 mt-6" />
                                                <div className="flex items-center justify-between mb-2">
                                                    <Typography className="text-md text-gray-600 pt-3">
                                                        Beneficiary {" "} {index + 1}
                                                    </Typography>
                                                    <button
                                                        type="button"
                                                        onClick={() => remove(index)}
                                                        className="top-2 right-2 text-red-500 hover:text-red-700 text-lg font-bold"
                                                        title="Remove this beneficiary"
                                                    >
                                                        <FiX size={20} />
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                        <div className="grid grid-cols-2 gap-4 mt-4">
                                            <Input
                                                crossOrigin="anonymous"
                                                size="lg"
                                                type="text"
                                                className="bg-gray-100 w-full px-5 py-4 text-sm rounded-2xl"
                                                label="First Name"
                                                defaultValue={beneficiary.first_name}
                                                {...register(`beneficiaries.${index}.first_name`, { required: false })}
                                            />

                                            <Input
                                                crossOrigin="anonymous"
                                                size="lg"
                                                className="bg-gray-100 w-full px-5 py-4 text-sm rounded-2xl"
                                                label="Last Name"
                                                defaultValue={beneficiary.surname}
                                                {...register(`beneficiaries.${index}.surname`, { required: false })}
                                            />

                                            <Input
                                                defaultValue={beneficiary.dob}
                                                crossOrigin="anonymous"
                                                size="md"
                                                type="date"
                                                className="!border-t-blue-gray-200 focus:!border-t-gray-900"
                                                labelProps={{
                                                    className: "before:content-none after:content-none",
                                                }}
                                                {...register(`beneficiaries.${index}.dob`, { required: false })}
                                            />

                                            <Input
                                                crossOrigin="anonymous"
                                                size="lg"
                                                className="bg-gray-100 w-full px-5 py-4 text-sm rounded-2xl"
                                                label="Email"
                                                defaultValue={beneficiary.email}
                                                {...register(`beneficiaries.${index}.email`, {
                                                    required: false,
                                                    pattern: {
                                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                        message: "Invalid beneficiary email address",
                                                    },
                                                })}
                                            />

                                            <Input
                                                crossOrigin="anonymous"
                                                size="lg"
                                                className="bg-gray-100 w-full px-5 py-4 text-sm rounded-2xl"
                                                label="Phone Number"
                                                defaultValue={beneficiary.phone_number}
                                                {...register(`beneficiaries.${index}.phone_number`, { required: false })}
                                            />

                                            <Input
                                                crossOrigin="anonymous"
                                                size="lg"
                                                className="bg-gray-100 w-full px-5 py-4 text-sm rounded-2xl"
                                                label="Address"
                                                defaultValue={beneficiary.address}
                                                {...register(`beneficiaries.${index}.address`, { required: false })}
                                            />

                                            <Input
                                                crossOrigin="anonymous"
                                                size="lg"
                                                className="bg-gray-100 w-full px-5 py-4 text-sm rounded-2xl"
                                                label="Relationship"
                                                defaultValue={beneficiary.relationship}
                                                {...register(`beneficiaries.${index}.relationship`, { required: false })}
                                            />

                                            <Input
                                                crossOrigin="anonymous"
                                                size="lg"
                                                className="bg-gray-100 w-full px-5 py-4 text-sm rounded-2xl"
                                                label="Percentage Share"
                                                defaultValue={beneficiary.share_percentage}
                                                {...register(`beneficiaries.${index}.share_percentage`, {
                                                    required: false,
                                                    min: {
                                                        value: 0,
                                                        message: "Share must be at least 0%",
                                                    },
                                                    max: {
                                                        value: 100,
                                                        message: "Share cannot exceed 100%",
                                                    },
                                                    validate: (value) =>
                                                        !isNaN(Number(value)) || "Must be a number",
                                                })}
                                            />
                                        </div>
                                    </React.Fragment>
                                ))}
                                <div className="flex items-center justify-between mt-6">
                                    <Button
                                        type="button"
                                        // onClick={addBeneficiary}
                                        onClick={() => append(createEmptyBeneficiary())}
                                        size="sm"
                                        className="capitalize flex items-center flex-row items-centerfont-normal bg-blue-600"
                                    >
                                        <BiPlus size={20} />
                                        Add Beneficiary
                                    </Button>
                                </div>
                            </div>
                            <div className="mt-5 mb-4 flex gap-4 items-end justify-end">
                                <Button
                                    type="submit"
                                    size="sm"
                                    // onClick = {handleSubmit(onSubmit, onError)}
                                    className="capitalize flex items-center flex-row items-centerfont-normal"
                                    style={{
                                        background:
                                            colors?.length! > 1
                                                ? `${colors![0]?.toLowerCase()}`
                                                : `${DEFAULTPRIMARYCOLOR}`,
                                    }}
                                >
                                    <FaSave size={20} className="mr-1" />
                                    {loading ? <Spinner className="w-4 h-4" /> : "Save"}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    )
}

export default DriverEdit
